module.exports = __webpack_public_path__ + "media/hyper/fonts/Nunito-Regular-328e9506b6f5c2f2622a24c105c83996.woff";